import React from 'react';

export const getAllByType = (children, component): JSX.Element[] => {
  const result = [];

  const type = component.displayName || component.name;

  React.Children.forEach(children, child => {
    const childType = child && child.type && (child.type.displayName || child.type.name);
    if (type === childType) {
      result.push(child);
    }
  });

  return result;
};
